module.exports = __webpack_public_path__ + "img/android.fd4ed981.svg";